import { render, staticRenderFns } from "./new-product-photo.vue?vue&type=template&id=12841cd9&scoped=true"
import script from "./new-product-photo.vue?vue&type=script&lang=js"
export * from "./new-product-photo.vue?vue&type=script&lang=js"
import style0 from "./new-product-photo.vue?vue&type=style&index=0&id=12841cd9&prod&lang=scss&scoped=true"
import style1 from "./new-product-photo.vue?vue&type=style&index=1&id=12841cd9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12841cd9",
  null
  
)

export default component.exports